import OrderItem from '../../../types/api/order-item'
import { defaultOrderItemRowResolver } from './default-resolver'
import { flexoformOrderItemRowResolver } from './flexoform-resolver'
import { labelOrderItemRowResolver } from './label-resolver'
import { ribbonOrderItemRowResolver } from './ribbon-resolver'
import { stampOrderItemRowResolver } from './stamp-resolver'
import { OrderItemRowResolver, OrderItemRowView } from './types'

const resolvers: Record<string, OrderItemRowResolver> = {
    label: labelOrderItemRowResolver,
    ribbon: ribbonOrderItemRowResolver,
    colorProof: labelOrderItemRowResolver,
    stamp: stampOrderItemRowResolver,
    flexoform: flexoformOrderItemRowResolver,
}

export function resolveOrderItemRow(item: OrderItem): OrderItemRowView {
    const slug = item.product_type?.slug
    const resolver = (slug && resolvers[slug]) || defaultOrderItemRowResolver
    return resolver(item)
}
